import React from 'react';
import { FlowSummary } from '../../../components/UI-Elements/Forms/FlowSummery';
import { Material } from '../../../sp-types/materialType';
import { Product } from '../../../sp-types/productType';
import { formatToPriceInDollars } from '../../../utils/FormatValue';
import { useCurrencyRates } from '@hooks/useCurrencyRates';

interface Props {
  product: Product;
  submit: () => void;
  isLoading: boolean;
  isSubmitDisabled: boolean;
  cancel: () => void;
  materialsMap: Record<string, Material>;
  isEditable?: boolean;
}

export const AddNewProductSummary: React.FC<Props> = ({
  cancel,
  product,
  submit,
  materialsMap,
  isLoading,
  isSubmitDisabled,
  isEditable = true,
}) => {
  const { pricesMap } = useCurrencyRates();

  return (
    <FlowSummary
      title="Product summary"
      subTitle="Here are the highlights of your product"
      onPrimaryClick={{ text: 'Submit', function: submit, isDisabled: isSubmitDisabled, isLoading }}
      onSecondaryClick={{ text: 'Cancel', function: cancel, isLoading }}
      isEditMode={isEditable}
      dataToPresent={[
        { title: 'Product Id', placeHolder: 'set product id', value: product?.id || '' },
        { title: 'Product name', placeHolder: 'set product name', value: product.name },
        { title: 'Measure by', placeHolder: 'set measure unit', value: product.measureType },
        { title: 'Category', placeHolder: 'set category', value: product.category },
        { title: 'Sub category', placeHolder: 'set sub category', value: product.subCategory },
        ...product.ingredients.map((item, index: number) => ({
          title: `Material ${index + 1}`,
          placeHolder: `set material ${index + 1}`,
          value: `${materialsMap[item.materialID].name} (${formatToPriceInDollars(pricesMap[item.materialID])})`,
        })),
      ]}
    />
  );
};
